export class ShowCancelledButton {
  text = "No";
  enabled = false;
}
